var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"alignment":"center"}},[_c('vs-tab',{attrs:{"label":"Import Periodo Individual"}},[_c('div',[_c('importPeriodoIndividualVue')],1)]),_c('vs-tab',{attrs:{"label":"Import por varios periodos"}},[_c('div',[_c('importPeriodoVariosVue')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }